<template>
  <div class="w-56" v-if="wocos.length > 0">
    <MultiSelect
      :value="selectedWoco"
      :options="wocos"
      :searchable="true"
      :can-clear="false"
      :can-deselect="false"
      :disabled="wocos.length <= 1"
      placeholder="Selecteer een woco"
      no-options-text="Geen wocos beschikbaar"
      no-results-text="Geen woco gevonden"
      @input="onChange"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import MultiSelect from '@/components/shared/MultiSelect.vue'

export default {
  name: 'DropDown',
  components: { MultiSelect },
  computed: {
    ...mapState(['selectedWoco', 'user', 'selectedYear']),
    wocos() {
      return this.user.wocos
        .map((woco) => woco.name)
        .sort((a, b) => a.localeCompare(b, 'nl', { sensitivity: 'base', numeric: true }))
    },
  },
  watch: {
    user() {
      if (this.user.wocos.length === 1) {
        this.setSelectedWoco(this.user.wocos[0].name)
      }
    },
  },
  methods: {
    ...mapMutations(['setSelectedWoco', 'setSelectedYear']),
    onChange(value) {
      this.setSelectedWoco(value || null)

      // Reset year if the currently selected one is not available for the new woco
      const woco = this.user.wocos.find((w) => w.name === this.selectedWoco)

      if (woco === undefined) {
        return
      }

      if (!Object.keys(woco.available_years).includes(this.selectedYear)) {
        this.setSelectedYear(Object.keys(woco.available_years)[0])
      }
    },
  },
}
</script>
